import { render, staticRenderFns } from "./pareceres-mcti.vue?vue&type=template&id=8ac7421a&scoped=true&"
import script from "./pareceres-mcti.vue?vue&type=script&lang=js&"
export * from "./pareceres-mcti.vue?vue&type=script&lang=js&"
import style0 from "./pareceres-mcti.vue?vue&type=style&index=0&id=8ac7421a&scoped=true&lang=css&"
import style1 from "./pareceres-mcti.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac7421a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VRow,VSpacer})
